"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _configuration = require("../configuration");

var _default = function _default(pluginManager) {
  return (0, _configuration.ConfigurationSchema)('BaseAssembly', {
    aliases: {
      type: 'stringArray',
      defaultValue: [],
      description: 'Other possible names for the assembly'
    },
    sequence: pluginManager.getTrackType('ReferenceSequenceTrack').configSchema,
    refNameColors: {
      type: 'stringArray',
      defaultValue: [],
      description: 'Define custom colors for each reference sequence. Will cycle through this list if there are not enough colors for every sequence.'
    },
    refNameAliases: (0, _configuration.ConfigurationSchema)('RefNameAliases', {
      adapter: pluginManager.pluggableConfigSchemaType('adapter')
    }, {
      preProcessSnapshot: function preProcessSnapshot(snap) {
        // allow refNameAliases to be unspecified
        // @ts-ignore
        if (!snap.adapter) {
          return {
            adapter: {
              type: 'RefNameAliasAdapter'
            }
          };
        }

        return snap;
      }
    }),
    cytobands: (0, _configuration.ConfigurationSchema)('Cytoband', {
      adapter: pluginManager.pluggableConfigSchemaType('adapter')
    }, {
      preProcessSnapshot: function preProcessSnapshot(snap) {
        // allow cytoBand to be unspecified
        // @ts-ignore
        if (!snap.adapter) {
          return {
            adapter: {
              type: 'CytobandAdapter'
            }
          };
        }

        return snap;
      }
    }),
    displayName: {
      type: 'string',
      defaultValue: '',
      description: 'A human readable display name for the assembly e.g. "Homo sapiens (hg38)" while the assembly name may just be "hg38"'
    }
  }, {
    explicitIdentifier: 'name'
  });
};

exports.default = _default;